import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ProgressBarType} from "../../../components/shared/progress-bar/progress-bar.component";

@Component({
    selector: 'app-inline-textarea',
    templateUrl: './inline-textarea.component.html',
    styleUrls: ['./inline-textarea.component.scss'],
    standalone: false
})
export class InlineTextareaComponent implements OnInit {
  @Input() data: string = "";
  @Input() label: string = "";
  @Input() placeholder: string = "Enter text";
  @Input() disabledFlag: boolean;
  @Input() element: any = null; //AssessmentGoal, AssessmentObjective, AssessmentMeasure
  @Input() tabIndex: number = 0;
  @Input() maxChars: number = 0;
  @Input() shortText: boolean = false;
  @Input() hasCounter: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  editMode: boolean = false;
  tempValue: string = "";

  charsLeft:number = 0;
  percentage:number = 0;
  counterClass:string = "ok";
  progressBarColor: ProgressBarType = "primary";
  warningThreshold:number = 80;

  random: string = "" + new Date().getTime();


  constructor() {}

  ngOnInit() {
    if( this.maxChars != 0 ) {
      //this.charsLeft = this.maxChars - this.data.length;
      this.calculateCounters( this.data.length );
    }
  }

  changeCounters(event) {
    if(this.hasCounter) {
      this.calculateCounters( event.target.innerHTML.length );
    }
    if(this.shortText) {
      this.cutText(event);
    }
  }
  cutText(event) {
    if(event.target.innerHTML.length >= this.maxChars && !this.isAllowedKeyCode(event)) {
      event.preventDefault();
    }
  }
  /**
   * Check if a keycode is allowed when max limit is reached
   * 8 : Backspace
   * 37: LeftKey
   * 38: UpKey
   * 39: RightKey
   * 40: DownKey
   * ctrlKey for control key
   * metakey for command key on mac keyboard
   * @param {any} eventKeycode
   * @returns boolean
   */
  isAllowedKeyCode(event) {
    return event.keyCode === 8 || //backspace
      event.keyCode === 17 || //ctrl
      event.keyCode === 20 || //caps lock
      event.keyCode === 27 || //escape
      event.keyCode === 33 || //pgup
      event.keyCode === 34 || //pgdown
      event.keyCode === 35 || //end
      event.keyCode === 36 || //home
      event.keyCode === 37 || //arrows
      event.keyCode === 38 || //arrows
      event.keyCode === 39 || //arrows
      event.keyCode === 40 || //arrows
      event.keyCode === 46 || //delete
      event.keyCode === 144 || //numlock
      event.keyCode === 145 || //scrolllock
      event.ctrlKey ||
      event.metaKey;
  }

  calculateCounters(charLength) {
    this.calculatePercentageCharacters( charLength );
    this.calculateCharsLeft( charLength );
    this.calculateCounterClass( );
  }

  calculatePercentageCharacters(charsCount:number) {
    let percentage = ( charsCount * 100 ) / this.maxChars;
    if( percentage > 100 ) {
      percentage = 100;
    }
    this.percentage = Math.floor( percentage );
  }
  calculateCharsLeft(charsCount:number) {
    this.charsLeft = this.maxChars - charsCount;
  }

  calculateCounterClass() {
    this.counterClass = "ok";
    if( this.percentage < this.warningThreshold ) {
      this.counterClass = "ok";
      this.progressBarColor = "primary";
    } else if( this.percentage < 100) {
      this.counterClass = "warning";
      this.progressBarColor = "warn";
    } else {
      this.counterClass = "error";
      this.progressBarColor = "error";
    }
  }

  changeToEdit() {
    if( !this.disabledFlag ) {
      this.editMode = true;


    }
  }

  onFocusOut(value) {
    this.data = value.target.innerHTML;
    this.editMode = false;
    if(this.element){
      this.element.isBeingEdited = false;
    }
    this.data = this.sanitizeText(this.data);
    this.focusOut.emit( this.data );

  }

  startEdit() {
    this.tempValue = this.data;
    if(this.element){
      this.element.isBeingEdited = true;
    }
    this.editMode = true;
  }

  undo() {
    this.editMode = false;
    this.data = this.tempValue;
  }

  sanitizeText(text:string) {
    //new lines
    text = text.replace(/<div>/gi, "");
    text = text.replace(/<p>/gi, "");
    text = text.replace(/<br><\/div>/gi, "\n" );
    text = text.replace(/<br>/gi, "\n");
    text = text.replace(/<\/div>/gi, "\n" );
    text = text.replace(/<\/p>/gi, "\n" );
    //bold
    text = text.replace(/<b>/gi, "");
    text = text.replace(/<\/b>/gi, "" );
    text = text.replace(/&lt;b&gt;/gi, "");
    text = text.replace(/&lt;&bsol;b&gt;/gi, "" );
    //underline
    text = text.replace(/<u>/gi, "");
    text = text.replace(/<\/u>/gi, "" );
    text = text.replace(/&lt;u&gt;/gi, "");
    text = text.replace(/&lt;&bsol;u&gt;/gi, "" );
    //italics
    text = text.replace(/<i>/gi, "");
    text = text.replace(/<\/i>/gi, "" );
    text = text.replace(/&lt;i&gt;/gi, "");
    text = text.replace(/&lt;&bsol;i&gt;/gi, "" );
    //script
    text = text.replace(/<script>/gi, "");
    text = text.replace(/<\/script>/gi, "");
    text = text.replace(/&lt;script&gt;/gi, "");
    text = text.replace(/&lt;&bsol;script&gt;/gi, "" );

    let textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }
}
